// src/context/CsrfTokenContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
axios.defaults.withCredentials = true;

const CsrfTokenContext = createContext();

export const CsrfTokenProvider = ({ children }) => {
    const [csrfToken, setCsrfToken] = useState('');

    useEffect(() => {
        const fetchCsrfToken = async () => {
            const csrf_token = localStorage.getItem('csrfToken');
            //console.log('csrf_token', csrf_token);

            //   const response = await axios.get('/api/csrf-token', { withCredentials: true });
            //   setCsrfToken(response.data.csrfToken);
            setCsrfToken(csrf_token);
        };

        fetchCsrfToken();
    }, []);

    return (
        <CsrfTokenContext.Provider value={csrfToken}>
            {children}
        </CsrfTokenContext.Provider>
    );
};

export const useCsrfToken = () => {
    return useContext(CsrfTokenContext);
};
